"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.WelcomeModuleChildPath = void 0;
exports.WelcomeModuleChildPath = {
    tellMorePage: 'tell-me-more',
    clientAccounts: 'client-accounts',
    employmentStatus: 'employment-status',
    faq: 'faq',
    fileTaxes: 'file-taxes',
    ineligibleClient: 'ineligible-client',
    notAbleToPersonalize: 'not-able-to-personalize',
    serviceTempOutage: 'service-temporary-unavailable',
    steps: 'steps',
    quickCheckIn: 'quick-check-in',
    VMAPpostPersonalization: 'vmap-post-personalization',
    partnerConsent: 'partner-consent',
    pc7LandingPage: 'vmap-customize-profile',
    pc7ConfirmPage: 'vmap-customize-profile/confirm',
};
